import { render } from "./ChangeCredPage.vue?vue&type=template&id=974f8eaa&ts=true"
import script from "./ChangeCredPage.vue?vue&type=script&lang=ts"
export * from "./ChangeCredPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__